<template>
  <section class="category-section-four">
    <div class="container">
      <div class="row">
        <div class="col-md-12">

          <!-- section heading -->
          <div class="section-heading heading-four" data-aos="fade-down">
            <h2>عروض الوكالات</h2>
            <p>عارف أنت بتدور على إيه؟ تصفح مجموعتنا الواسعة من السيارات</p>
          </div>

          <!-- dynamic items -->
          <div class="row row-gap-4">
            <div 
              v-for="(offer, index) in visibleOffers" 
              :key="offer.id" 
              class="col-xl-2 col-md-4 col-sm-6 d-flex"
            >
              <div class="category-item flex-fill">
                <div class="category-info d-flex align-items-center justify-content-between">
                  <div class="category-text">
                    <h6 class="title">
                      <router-link :to="'/listing/listing-grid?brand=' + offer.brand?.name">
                        {{ offer.type || 'بدون نوع' }}
                      </router-link>
                    </h6>
                    <p>{{ offer.brand?.name }}</p>
                  </div>
                  <router-link :to="`/agency/${offer.id}`" class="link-icon">
                    <i class="bx bx-right-arrow-alt"></i>
                  </router-link>
                </div>
                <div class="category-img">
                  <img
                    :src="offer.images?.[0]?.image || require('@/assets/img/cars/no-car.jpg')"
                    alt="car image"
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Show More button -->
          <div class="view-all-btn text-center aos mt-4" data-aos="fade-down" v-if="homeStore.agencyOffers.length > visibleCount">
            <button class="btn-view-car btn-secondary" @click="visibleCount += 6">
              عرض المزيد <i class="bx bx-right-arrow-alt ms-1"></i>
            </button>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useHomeStore } from '@/stores/home'

const homeStore = useHomeStore()

const visibleCount = ref(6)

const visibleOffers = computed(() => homeStore.agencyOffers.slice(0, visibleCount.value))

// reset visibleCount when offers change
watch(
  () => homeStore.agencyOffers,
  () => {
    visibleCount.value = 6
  }
)

onMounted(() => {
  homeStore.fetchHomeData()
})
</script>

<style> 
.category-img {
  height: 150px; 
  overflow: hidden;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.category-img img {
  width: 100%;
  height: 100%;
  object-fit: cover; 
  display: block;
}
</style>
